<div class="modal-header" id="object-info-modal-title">
    <h3
        class="modal-title"
        id="modal-title-tid"
        *ngIf="!displayFuncLocInfoHeader"
        translate="NOTIFICATION_DETAILS_DETAIL_LINKS_TID_INFO_TITLE"
    ></h3>
    <h3
        class="modal-title"
        id="modal-title-fl"
        *ngIf="displayFuncLocInfoHeader"
        translate="NOTIFICATION_DETAILS_DETAIL_LINKS_FL_INFO_TITLE"
    ></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <p class="col-12" [innerHtml]="notification.objectInformationLongText"></p>
    </div>
</div>
